export default __webpack_public_path__ + "static/media/img_cart_empty.be20a9cb.svg";